import { inject, observer } from 'mobx-react';
import Login from 'models/Login';
import React, { FC, useEffect } from 'react';
import { openPostWindow } from 'utils/postWindowUtils';

interface IApplicantInfoView {
    loginInfo?: Login;
}

//css Frame.tsx에 있음 

const ApplicantInfoView: FC<IApplicantInfoView> = (props: IApplicantInfoView) => {
    const { loginInfo } = props;

    useEffect(() => {
        const init = async () => {
            await loginInfo!.getUserInfo();
            await loginInfo!.getCompanyInfo();

        }
        init();
    }, [])


    if (loginInfo == undefined) return <div></div>
    if (loginInfo!.companyInfo == undefined) return <div></div>

    return (
        <div className='jobview-info-frame'>
            <div className='user-frame'>{`${loginInfo.userInfo!.name} ${loginInfo.userInfo!.recruitNoticeName} ${loginInfo.userInfo!.recruitSectorName}`}</div>
            <button className='guide-btn' onClick={() => {
                openPostWindow(
                    '/stepguide',
                    '온라인 PT 가이드',
                    'width=1127,height=900,location=no,status=no,scrollbars=yes',
                    { success: true }
                );
            }}></button>
        </div>
    )
};
export default inject('loginInfo')(observer(ApplicantInfoView));
